export enum Environment {
  UAT = 'uat',
  PROD = 'prod',
}
